import '@babel/polyfill'
import 'mutationobserver-shim'
import Raphael from 'raphael/raphael'
global.Raphael = Raphael
import Vue from 'vue'
import './plugins'
import App from './App.vue'
import router from './router'
import store from './store'
import './directives'
import 'leaflet/dist/leaflet.css';

import ApolloClient from 'apollo-client'
// import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import VueApollo from 'vue-apollo'
import { createUploadLink } from 'apollo-upload-client'
import { ApolloLink } from 'apollo-link'

import moment from 'moment'
import { BVToastPlugin, FormDatepickerPlugin } from 'bootstrap-vue'
// import VueMaterial from 'vue-material'
// import 'vue-material/dist/vue-material.min.css'
// import 'vue-material/dist/theme/default.css'


import VueSingleSelect from "vue-single-select"
import Multiselect from 'vue-multiselect'
import datetimePicker from 'vue-bootstrap-datetimepicker';
import 'vue2-timepicker/dist/VueTimepicker.css'
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css'; // Import Vuetify CSS
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify, {
  icons: {
    iconfont: 'mdi', // This should match the icon font you are using
  },
});

Vue.config.productionTip = false
Vue.use(VueApollo);

Vue.component('vue-single-select', VueSingleSelect);
Vue.component('multiselect', Multiselect);
Vue.use(BVToastPlugin);
Vue.use(FormDatepickerPlugin);
Vue.use(datetimePicker);


//Format for DateTime
Vue.filter('DateTimeFormat', function (value) {
  if (value) {
    return moment(String(value)).format('hh:mm A, [\r\n] ddd, MMMM D')
  }
});

//Format for Date
Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('hh:mm A, D MMM YYYY')
  }
});

//Format for Date without year
Vue.filter('dateDayFormat', function (value) {
  if (value) {
    return moment(String(value)).format('ddd, DD MMM')
  }
});

//Format for Date with year
Vue.filter('dateDayYearFormat', function (value) {
  if (value) {
    return moment(String(value)).format('ddd, DD MMM YYYY')
  }
});

//Format for Date
Vue.filter('timeFormat', function (value) {
  if (value) {
    return moment(String(value)).format('hh:mm A')
  }
});

// Format for Time (convert 24hrs to 12hrs)
Vue.filter('formatTime', function(value) {
  if(value){
    const timeString12hr = new Date('1970-01-01T' + value + 'Z')
      .toLocaleTimeString('en-US',
        { timeZone: 'UTC', hour12: true, hour: 'numeric', minute: 'numeric' }
      );
    return timeString12hr
  }
})

//Convert SERV_NAME to Title Case
Vue.filter('customTitleCase', function (value) {
  if (value) {
    return value.replace("_", " ").replace(/\w\S*/g,
      function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }
    );
  }
});



// 1️⃣ Create upload link
const uploadLink = createUploadLink({
  uri: process.env.VUE_APP_API_ENDPOINT,
  fetch,
  credentials: 'omit',
})

// 2️⃣ Create auth middleware link
const authLink = new ApolloLink((operation, forward) => {
  const token = localStorage.getItem('apollo-token')

  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      accept: 'application/json',
      'content-type': 'application/json',
      'X-Client': process.env.VUE_APP_API_CLIENT,
      Authorization: token ? `JWT ${token}` : '',
    },
  }))

  return forward(operation)
})

// 3️⃣ Combine both links
const link = authLink.concat(uploadLink)

// 4️⃣ Create Apollo client
export const client = new ApolloClient({
  link,
  cache: new InMemoryCache({ addTypename: true }),
  defaultOptions: {
    query: {
      fetchPolicy: 'no-cache',
    },
  },
})

const apolloProvider = new VueApollo({
  defaultClient: client,
})

new Vue({
  router,
  store,
  vuetify: new Vuetify(),
  apolloProvider,
  render: h => h(App)
}).$mount('#app')
